/** Presentation-only human labels — stored enum values unchanged. */

export function learnerInitials(displayName) {
  const parts = String(displayName || "?")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return (parts[0]?.slice(0, 2) || "??").toUpperCase();
}

export function entitlementLabel(code) {
  const map = {
    TRAINING_ENABLED: "Training enabled",
    PUBLIC_BASIC: "Theory access only",
  };
  return map[code] || code || "Access pending";
}

export function workflowTabLabel(kind) {
  const map = {
    QUICK_DAILY_FEEDBACK: "Quick Daily Feedback",
    DETAILED_ASSESSMENT: "Detailed Assessment",
    MOCK_READINESS: "Mock / Readiness",
    QUICK_LESSON: "Quick Lesson",
  };
  return map[kind] || kind;
}

export function publicationLabel(state) {
  const map = {
    DRAFT: "Draft",
    APPROVED: "Approved",
    PUBLISHED: "Published",
    LEGACY: "Published",
  };
  return map[state] || state || "Draft";
}

export function readinessLabel(state) {
  const map = {
    NOT_READY: "Not Ready",
    DEVELOPING: "Developing",
    NEARLY_READY: "Nearly Ready",
    READY_FOR_MOCK: "Ready for Mock",
    TEST_READY: "Test Ready",
  };
  return map[state] || state;
}

export function shareStateLabel(state) {
  const map = {
    NOT_SHAREABLE_EXTERNALLY: "Instructor only",
    SHAREABLE_EXTERNALLY: "Shareable externally",
  };
  return map[state] || state;
}
